import { Fragment, Slice } from 'prosemirror-model';
import { useCallback } from 'react';
import { INSERT_IMAGE, LOAD_IMAGE } from '../../draft-transplant/utils/prosemirrorImageActionTypes';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InlineImage({
  ImageButton,
  onPluginOpenModal,
  onPluginCloseModal,
  onInsertContent
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const handleImageActions = useCallback(action => {
    const {
      actionType,
      data
    } = action;
    if (actionType === INSERT_IMAGE || actionType === LOAD_IMAGE) {
      const {
        schema
      } = editorState;
      let tr = editorState.tr;
      const imageNode = schema.nodes.image.create({
        src: data.src,
        isTemporary: actionType === LOAD_IMAGE,
        uploadPercent: 0,
        originalDimensions: data.originalDimensions,
        width: data.width,
        height: data.height,
        fileToUpload: actionType === LOAD_IMAGE ? data.fileToUpload : null,
        fileManagerAccess: data.fileManagerAccess
      });
      tr = tr.replaceSelection(new Slice(Fragment.fromArray([schema.nodes.paragraph.create(), imageNode, schema.nodes.paragraph.create()]), 0, 0));
      setEditorState(editorState.apply(tr));
      if (onInsertContent) onInsertContent();
    }
  }, [editorState, setEditorState, onInsertContent]);
  return /*#__PURE__*/_jsx(ImageButton, {
    editorState: null,
    onChange: handleImageActions,
    onPluginCloseModal: onPluginCloseModal,
    onPluginOpenModal: onPluginOpenModal,
    useProsemirror: true
  });
}